import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
  Spinner,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Select from "react-select"
//Import Breadcrumb
import Breadcrumb_2Items from "../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { postSubmitForm } from "../../../helpers/forms_helper";
import showNotification from "../../../helpers/show_notification";
import preloader from "../../../helpers/preloader";
import calculatePrice from "../../../helpers/calculate_price";
import { formatUnitsForReport, GetUpdatedDelivered } from "../../../helpers/units";
import UpdateQuantityForPoModal from "../../../components/UpdateQuantityForPoModal";
import EnterQuantityForPoModal from "../../../components/EnterQuantityForPoModal";
import AllDrafts from "../Draft/AllDrafts";

const SupplierWiseRequisition = (props) => {
  const [cartItems, setCartItems] = useState([]);
  const [cartModal, setCartModal] = useState(false)
  const [disableSubmit, setDisableSubmit] = useState(false);

  useEffect(() => {
    loadAllSuppliers();
    loadDraftOrders();
  }, []);

  const [selectedItems, setSelectedItems] = useState([]);
  const [selectUnitModal, setSelectUnitModal] = useState(false);
  const [editUnitModal, setEditUnitModal] = useState(false);

// Load all Suppliers
  const [allSuppliers, setAllSuppliers] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState();
  const loadAllSuppliers = async () => {
    let url = process.env.REACT_APP_BASEURL + "suppliers/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllSuppliers(response.data);
      setSelectedDraftID("")
    } else {
      showNotification(response.message, "Error");
    }
  };
  
  useEffect(() => {
    if (selectedSupplier) {loadItems();
    setCartItems([])}
    else {
      setAllItems([]);
      setFilteredItems([]);
    }
  }, [selectedSupplier]);


//   Load all items 
  const [searchkey, setSearchKey] = useState("");
  const [allItems, setAllItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);

  const loadItems = async (supplier_id=null) => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "items/get_supplierwise_for_po";
    // const response = await postSubmitForm(url, { supplier_id: selectedSupplier.value });
    const response = await postSubmitForm(url, {
      supplier_id:
      supplier_id === null ? selectedSupplier && selectedSupplier.value : supplier_id,
    });
    if (response && response.status === 1) {
      const updatedItems = response.data.map((item) => {
        return {
          ...item,
          total_price: 0,
        };
      });
      const SortedData = updatedItems.sort((a,b)=>a.name.localeCompare(b.name))
      preloader(false);
      setAllItems(SortedData);
      setFilteredItems(SortedData);
      setDisableSubmit(false);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
    
  };


  useEffect(() => {
    filterItems(allItems);
  }, [searchkey]);

//   filter items 
const filterItems = async (allItems) => {
  let filteredItems;
  if (!searchkey || searchkey.trim() === "") {
    filteredItems = allItems;
  } else {
    filteredItems = allItems?.filter((item) => {
      return (
        item.name.toLowerCase().includes(searchkey.toLowerCase()) ||
        item.category.toLowerCase().includes(searchkey.toLowerCase())
      );
    });
  }
  setFilteredItems(filteredItems);
};

  const columns_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "item_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      editable: false,
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "45%" };
      },
      editable: false,
    },
    {
      text: props.t("Cat."),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
    },
    {
      text: props.t("Sub-Cat."),
      dataField: "sub_category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
    },
    {
      text: props.t("Brand"),
      dataField: "brand",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
    },
  ];

  const handleDeleteRow = (itemId) => {
    setCartItems((prevCartItems) => {
      const updatedCartItems = prevCartItems.filter((item) => item.item_id !== itemId);
      return updatedCartItems;
    });
  };
  
  const columns_cartitems = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "item_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      sort: false,
      footer: false,
      editable:false,
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      footer: false,
      editable:false,
    },
    {
      text: props.t("Quantity"),
      dataField: "quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return (
          <>
            <div className="d-flex align-items-center justify-content-between">
            <span className="me-2">
                {formatUnitsForReport(row.quantity)}
              </span>

                <Button
                  className="btn btn-success btn-sm"
                  onClick={() => {
                    setSelectedItems(row)
                    setSelectedRowsUnit(row.quantity);
                    setEditUnitModal(true);
                  }}
                >
                  <i class="mdi mdi-edit"></i>
                  {props.t("Edit")}
                </Button>
            </div>
          </>
        )
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },
    
    {
      text: props.t("Price"),
      dataField: "price",
      formatter:(cell,row)=>{
        return (row.price)+" / "+row.unit_for_po
      },
      sort: false,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      footer: false,
    },
    {
      text: props.t("Total"),
      dataField: "total_price",
      formatter:(cell,row)=>{
        return row.total_price.toFixed(2)
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      editable: false,
      footer: (columnData) => {
        const total = columnData.reduce((acc, item) => acc + item, 0);
        return total.toFixed(2);
      },
    },
    {
      dataField: "",
      editable:false,
      text: "Remove",
      formatter: (cell, row) => {
        return (
          <span className="d-flex justify-content-center text-danger">
            <i
              className="bx bxs-trash font-size-20"
              title="Click to Remove"
              style={{ cursor: "pointer" }}
              onClick={() => {
               handleDeleteRow(row.item_id)
              }}
            ></i>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      sort: false,
      footer: false,
    },
  ];

  const populateCartFromDraft = async (draftPO) => {
    setIsLoadingDraft(true);
    const supplier = {
      label: draftPO.supplier.name,
      value: draftPO.supplier._id,
      ...draftPO.supplier,
    };
    await loadItems(supplier.value);
    setSelectedSupplier(supplier);
    setCartItems(draftPO.items);
    setIsLoadingDraft(false);
  };

  const [selectedDraftID, setSelectedDraftID] = useState("");
  const handleDraftPOSelection = (row) => {
    // return
    setSelectedDraftID(row._id);
    populateCartFromDraft(row);
    setOpenDraftModal(false);
  };

  const selectDraftPORow = {
    mode: "checkbox",
    clickToSelect: true,
    hideSelectAll: true,
    onSelect: (row, isSelect, rowIndex, e) => {
      if (isSelect) {
        handleDraftPOSelection(row);
      }
    },
    selected: [selectedDraftID],
  };

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    hideSelectColumn: true,
    bgColor: '#ecf0a1',
    selected: cartItems.map(item => item.item_id),
    nonSelectable: cartItems
    .filter(cartItem => filteredItems.some(filterItem => filterItem.item_id === cartItem.item_id))
    .map(item => item.item_id),
    onSelect: (row, isSelect, rowIndex, e) => {
        if (isSelect) {
          setSelectedItems(row);
          SelectDefaultUnit(row);
          updateSelectedItems(row, isSelect);
        } else {
          e.preventDefault();
        }

    },
  };

  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);

  function SelectDefaultUnit(row) {
    setSelectedRowsUnit([
      {
        index: 0,
        unit: row.unit_levels[0].unit,
        formula: row.unit_levels[0].value,
        value: 0,
        isChecked: true,
      },
    ]);
    setSelectUnitModal(true);
  }

  function updateSelectedItems(row, isSelect) {
    setCartItems((prevSelected) => {
      if (isSelect) {
        if (!prevSelected.some(item => item.item_id === row.item_id)) {
          return [...prevSelected, row];
        }
      } else {
        const isnoUnitsSelected = selectedRowsUnit.every(unit => !unit.isChecked);
        if (isnoUnitsSelected) {
          return prevSelected.filter(item => item.item_id !== row.item_id);
        }
      }
      return prevSelected;
    });
  }

  const handleSubmitRequisition = async () => {   
    let items_arr = [];
     items_arr = cartItems.map((item) => ({

        item_id: item.item_id,
        name: item.name,
        category: item.category,
        sub_category: item.sub_category,
        brand: item.brand,
        unit_levels:item.unit_levels.map(({unit,value})=>({unit,value})),
        unit_for_po:item.unit_for_po,
        quantity: item.quantity.map(({ unit, value }) => ({ unit, value })) || null, 
        price: item.price,
        total_price: item.total_price.toFixed(2),
              }))

//    return
   
      try {
        if(!selectedSupplier){
          showNotification("Please select supplier ","Warning")
          return
        }
        else if (cartItems?.some((item) =>item.quantity?.length>0 &&item.quantity.every(({ value }) => (value == 0 || value == "0" || value === "")))) {
          showNotification("Please enter a valid quantity for at least one unit", "Warning");
             return;
           }
        if (cartItems.length > 0) {
          setDisableSubmit(true);
          let data = [{ supplier: selectedSupplier.value, items: items_arr ,draft_id: selectedDraftID}];
          let url = process.env.REACT_APP_BASEURL + "purchaseorders/insert";
          // console.log(data_to_send);
          let response = await postSubmitForm(url, {items:data});
          if (response.status === 1) {
            showNotification(response.message, "Success");
            setCartItems([])
            setCartModal(!cartModal)
            setSelectedDraftID("")
            setSelectedItems([])
            setSelectedSupplier("")
            setSelectedRowsUnit([])
            loadDraftOrders();
            for (let i = 0; i < response.data.length; i++) {
              window.open(
                `/purchase_order?po_id=${response.data[i]}`,
                "_blank"
              );
            }
            // window.location.reload();
          } else {
            setDisableSubmit(false)
            showNotification(response.message, "Error");
          }
        } else {
          setDisableSubmit(false)
          showNotification(
            "Please select at least one item and supplier.",
            "Error"
          );
        }
      } catch (error) {
        setDisableSubmit(false)
        showNotification(error.message, "Error");
      }
 
  };

  const handleSubmitDraft = async () => {

       //  return
       try {
        if(!selectedSupplier){
          showNotification("Please select supplier ","Warning")
          return
        }
       else if (cartItems?.some((item) =>item.quantity?.length>0 &&item.quantity.every(({ value }) => (value == 0 || value == "0" || value === "")))) {
        showNotification("Please enter a valid quantity for at least one unit", "Warning");
           return;
         }
         if (cartItems.length > 0) {
          let payload = {
             supplier: selectedSupplier,
             items: cartItems,
             draft_id: selectedDraftID, 
             type:"Supplier_Wise"
            };
           let url = process.env.REACT_APP_BASEURL + "po_draft/save_draft";
           let response = await postSubmitForm(url, payload);
           if (response.status === 1) {
             showNotification(response.message, "Success");
             setDisableSubmit(false);
             setSelectedDraftID("");
             loadDraftOrders();
             setCartItems([]);
             setSelectedSupplier("")
             setCartModal(!cartModal);
             setSelectedItems([]);
             setSelectedRowsUnit([]);      
           } else {
             showNotification(response.message, "Error");
           }
         } else {
           showNotification(
             "Please select at least one item and supplier.",
             "Error"
           );
         }
       } catch (error) {
         showNotification(error.message, "Error");
       }
  };

  const handleAddUnits = (qty) => {
    let convertedQuantity =  GetUpdatedDelivered(qty, selectedItems?.unit_levels) 
    const updatedCartItems = cartItems.map(item => {
      if (item.item_id === selectedItems.item_id) {
        const total_price = calculatePrice(selectedItems.unit_levels,convertedQuantity, item.price,item.unit_for_po);
        return { ...item, quantity: convertedQuantity, total_price };
      } else {
        return item;
      }
    });

    setCartItems(updatedCartItems);
    setSelectUnitModal(false);
    setSelectedItems([]);
    setSelectedRowsUnit([]);
  };

  function handleCloseModal() {
    const hasValidquantity = selectedItems?.quantity && 
    selectedItems.quantity.every(unit => unit.value > 0);
  if (!hasValidquantity) {
    setCartItems((prevCartItems) =>
      prevCartItems.filter((item) => item.item_id !== selectedItems.item_id)
    );
  }
    setSelectUnitModal(false);
  }


  const handleUpdateUnit = (qty) => {
    let convertedQuantity =  GetUpdatedDelivered(qty, selectedItems?.unit_levels) 
    const isItemInCart = cartItems.some(item => item.item_id === selectedItems.item_id);
    if (isItemInCart) {
      const updatedCartItems = cartItems.map(item =>
        item.item_id === selectedItems.item_id
          ? {
              ...item,
              quantity:convertedQuantity,
              total_price: calculatePrice(item.unit_levels,convertedQuantity,item.price,item.unit_for_po),
            }
          : item
      );
      setCartItems(updatedCartItems);
      setEditUnitModal(false);
    } else {
      const newItem = {
        ...selectedItems,
        quantity: convertedQuantity,
        total_price: calculatePrice(selectedItems.unit_levels,convertedQuantity,selectedItems.price,selectedItems.unit_for_po),
      };
      setCartItems(prevCartItems => [...prevCartItems, newItem]);
      setEditUnitModal(false);
    }
  
  };

  const [isLoadingDraft, setIsLoadingDraft] = useState(false);
  const [openDraftModal, setOpenDraftModal] = useState(false);
  const [draftOrders, setDraftOrders] = useState([]);
  const loadDraftOrders = async () => {
    let url = process.env.REACT_APP_BASEURL + "po_draft/get_draft";
    let response = await postSubmitForm(url, {type:"Supplier_Wise"});
    if (response.status === 1) {
      setDraftOrders(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const handleSupplierSelection = (selectedOption) => {
    setSelectedSupplier(selectedOption);
    setCartItems([]);
    setSelectedDraftID("");
    loadItems(selectedOption.value);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
        <Breadcrumb_2Items
            alternateTitle={props.t("Supplier-wise Purchase Order")}
            title={props.t("Procurement")}
            breadcrumbItem1={props.t("Supplier-wise Purchase Order")}
          />
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody style={{height:"100px"}}>
                  <AvForm>
                    <Row>
                      <Col lg={12}>
                        <AvField
                          name="search"
                          label={props.t("Search")}
                          placeholder={props.t("Search items here")}
                          type="text"
                          onChange={(e) => {
                            e.preventDefault();
                            setSearchKey(e.target.value);
                          }}
                        ></AvField>
                      </Col>
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
            <Col lg={6}>
              <Card>
                <CardBody style={{height:"100px"}}>
                  <AvForm>
                    <Row>
                      <Col lg={12}>
                        <Label>{props.t(" Supplier")}</Label>
                      <Select
                                  options={allSuppliers}
                                  // onChange={(se)=>setSelectedSupplier(se)}
                                  onChange={handleSupplierSelection}
                                  value={selectedSupplier}
                                  classNamePrefix="select"
                                  required
                                />
                      </Col>
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        {/* {filteredItems.length>0 && ( */}
            <Row>
            <Col lg={12}>
              <Card>
                <CardBody >
                 {filteredItems?.length<=0 ? (
 <Row>
 <Col md={6} lg={6} className="text-right">
     <div>
       <Button
         type="submit"
         color="success"
         className="mb-2"
         onClick={() => setOpenDraftModal(true)}
       >
         {props.t("View Draft PO")}
       </Button>
     </div>
   </Col>
   <Col md={6} lg={6} className="text-start">
   <div>
       <Button
         type="submit"
         color="primary"
         className="mb-2"
         onClick={() =>
           setCartModal(!cartModal)
         }
       >
         {props.t("View Cart")}
       </Button>
     </div>
   </Col>
 </Row>
                 ):(
                  <Row>
                  <Col md={6} lg={6} className="text-start">
                      <div>
                        <Button
                          type="submit"
                          color="success"
                          className="mb-2"
                          onClick={() => setOpenDraftModal(true)}
                        >
                          {props.t("View Draft PO")}
                        </Button>
                      </div>
                    </Col>
                    <Col md={6} lg={6} className="d-flex justify-content-end text-align-end"
>
                      <div>
                        <Button
                          type="submit"
                          color="primary"
                          className="mb-2"
                          onClick={() =>
                            setCartModal(!cartModal)
                          }
                        >
                          {props.t("View Cart")}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                 )}
                    {filteredItems.length>0 && (
                       <ToolkitProvider
                       bootstrap4
                       keyField="item_id"
                       data={filteredItems}
                       columns={columns_items}
                       noDataIndication={props.t("No data to display.")}
                       search
                     >
                       {(props) => (
                         <div>
                            <Row>
                        
                       </Row>
                           <BootstrapTable
                             striped
                             hover
                             selectRow={selectRow}
                             condensed
                             {...props.baseProps}
                           />
                         </div>
                       )}
                     </ToolkitProvider>
                    )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        {/* )} */}

          {/* Cart deatils start  */}
          <Modal
            size="lg"
            isOpen={cartModal}
            toggle={() => setCartModal(!cartModal)}
          >
            <ModalHeader
              toggle={() => setCartModal(!cartModal)}
            >
              {props.t("Review Order Details")}
            </ModalHeader>
            <ModalBody>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={12}>
                      <Row>
                        <Col lg={12}>
                         
                                 <Row>
                            <Col lg={8}>
                              {/* <Label>{props.t("Category")}: {item.category}</Label> */}
                            </Col>
                         
                          </Row>
                                <ToolkitProvider
                                bootstrap4
                                keyField="item_id"
                                data={cartItems}
                                columns={columns_cartitems}
                                noDataIndication={props.t("No data to display.")}
                                search
                              >
                                {(props) => (
                                  <div>
                                    <BootstrapTable
                                      striped
                                      hover
                                      condensed
                                      cellEdit={cellEditFactory({
                                        mode: "click",
                                        blurToSave: true,
                                        afterSaveCell: (
                                          oldValue,
                                          newValue,
                                          row,
                                          column
                                        ) => {
                                          
                                          // console.log(row.price, row.quantity);
                                        },
                                      })}
                                      {...props.baseProps}
                                    />
                                  </div>
                                )}
                              </ToolkitProvider>
                    
        
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={12}>
                      <FormGroup className="mb-0 text-center">
                        <div>
                          <Button
                            type="submit"
                            color="primary"
                            className="mr-2"
                            style={{width:"120px"}}
                            disabled={disableSubmit}
                            onClick={handleSubmitRequisition}
                          >
                          {disableSubmit ? <Spinner size="sm" /> : props.t("Generate")} 
                          </Button>
                          <Button
                            type="submit"
                            // style={{backgroundColor: "#e38484"}}
                            disabled={cartItems?.length <= 0}
                            onClick={() => handleSubmitDraft()}
                          >
                            {props.t("Save as Draft")}
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </ModalBody>
          </Modal>
          {/* Cart details end */}

          {/* Draft Modal start  */}
           <AllDrafts
                      isOpen={openDraftModal}
                      toggle={() => setOpenDraftModal(!openDraftModal)}
                      title={props.t("All Draft Purchase Orders")}
                      data={draftOrders}
                      keyField="_id"
                      selectRow={selectDraftPORow}
                      noDataMessage={props.t("No data to display.")}
                      onDelete={()=>loadDraftOrders()}
                      showSupplierColumn={true}
                       storeType="Central Store"
                    />
          {/* Draft Modal end  */}


          {/* Add quantity modal start */}
          <EnterQuantityForPoModal 
          isOpen={selectUnitModal}
          toggle={handleCloseModal}
          onSubmit={handleAddUnits}
          item={selectedItems}
          selectedUnits={selectedRowsUnit}
          cartItems={cartItems}
          setCartItems={setCartItems}
          selectedItems={selectedItems}
          />


          {/* Edit quantity Modal Start */}
          <UpdateQuantityForPoModal 
          isOpen={editUnitModal}
          toggle={()=>setEditUnitModal(false)}
          onSubmit={handleUpdateUnit}
          item={selectedItems}
          selectedUnits={selectedRowsUnit}
          cartItems={cartItems}
          setCartItems={setCartItems}
          selectedItems={selectedItems}
          />
          {/* Edit quantity modal end */}

        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(SupplierWiseRequisition))
);
